import { TableActionsWrapper } from '@components'

import { ReactElement } from 'react'

import { useQuotesList } from '../../context/quotesList'
import { QuotesPeriodSelector } from './elements/QuotesPeriodSelector'
import { QuotesSearch } from './elements/QuotesSearch'
import { QuotesTitle } from './elements/QuotesTitle'

export const QuotesTableActions = (): ReactElement | null => {
  const { options } = useQuotesList()

  const { showPeriodSelector, showSearch, showTitle } = options

  if (!showPeriodSelector && !showSearch && !showTitle) {
    return null
  }

  return (
    <TableActionsWrapper>
      {showTitle && <QuotesTitle />}
      {showSearch && <QuotesSearch />}
      {showPeriodSelector && <QuotesPeriodSelector />}
    </TableActionsWrapper>
  )
}
